export const photos = [
  {
    src: "/Images/gallery Images/img1.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/Images/gallery Images/img2.jpg",
    width: 1,
    height: 1
  },
  {
    src: "/Images/gallery Images/img3.jpg",
    width: 4,
    height: 4
  },
  {
    src: "/Images/gallery Images/img4.jpg",
    width: 4,
    height: 4
  },
  {
    src: "Images/gallery Images/img5.jpg",
    width: 3,
    height: 4
  },
  {
    src: "Images/gallery Images/img6.jpg",
    width: 4,
    height: 3
  },
  {
    src: "Images/gallery Images/img7.jpg",
    width: 3,
    height: 4
  },
  {
    src: "Images/gallery Images/img8.jpg",
    width: 4,
    height: 3
  },
  {
    src: "Images/gallery Images/img9.jpg",
    width: 4,
    height: 3
  },
   {
    src: "/Images/gallery Images/img10.jpg",
    width: 5,
    height: 4
  },
  {
    src: "Images/gallery Images/img11.jpg",
    width: 7,
    height: 4
  },
  {
    src: "Images/gallery Images/img12.jpg",
    width: 8,
    height: 8
  },
  {
    src: "Images/gallery Images/img13.jpg",
    width: 3,
    height: 4
  },
  {
    src: "Images/gallery Images/img14.jpg",
    width: 4,
    height: 3
  },
  {
    src: "Images/gallery Images/img15.jpg",
    width: 4,
    height: 3
  }
];
